<script>
import Constants from './../constants';
import store from './../store';

export default {
  name: 'MixinLayout',
  methods: {
    /**
     * Allows title customization based on stores' values
     * If no customization is possible will simply returns the page libelle
     * @param module The module infos (should contains at least a `name` prop)
     * @param page The page infos  (should contains at least `libelle` and `name` props and be used in conjunction
     * with `module` param)
     * @param infosPage Can be used alone and should at least contains
     * @returns {string|*|string} The page name
     */
    getLibelle({ module, page, infosPage }) {
      if (!(module && page) && !infosPage) {
        console.error('Params module & page should be given, or infosPage');
        return '';
      }

      const pageName = page ? page.name : infosPage.name_page;
      const pageLibelle = page ? page.display_name : infosPage.libelle_page;
      const moduleName = module ? module.name : infosPage.name_module;

      if ([Constants.PAGE_NEOPASS_FORM_DOCUMENTS].includes(pageName)) {
        return false;
      }

      if (
        [
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES,
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE,
          'langue',
        ].includes(pageName) ||
        [Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO].includes(
          moduleName
        )
      ) {
        const templateName =
          page && page.templates.length > 0
            ? page.templates[0].name
            : pageLibelle;
        return templateName;
      }

      if (
        [
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES,
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES,
        ].includes(moduleName)
      ) {
        const isPostPage =
          /^p([0-9]+)$/.exec(pageName) || /^f([0-9]+)$/.exec(pageName);

        if (isPostPage) {
          const index = parseInt(isPostPage[1]) - 1;

          const job = this.$store.getters['jobs/userJobs'][index]
            ? this.$store.getters['jobs/userJobs'][index].sheet
            : this.$store.getters['jobs/getPostByIndex'](index);

          if (job) {
            if (job.deleted_at != null) {
              return `${pageLibelle} : Fiche de poste inexistante`;
            }
            return `${pageLibelle} : ${job.name}`;
          }
          if (!this.$can(pageName + '_edit')) {
            return false;
          }
        }
      }

      return pageLibelle;
    },

    $showSaveButton(form) {
      return (
        !Constants.LIST_EVALUATION_PAGES.includes(
          store.getters['neopass/infosPage'].name_page
        ) ||
        ((form ? true : false) &&
          (form || {}).date_debut_evaluation &&
          (form || {}).date_debut_evaluation != '' &&
          (form || {}).date_fin_evaluation &&
          (form || {}).date_fin_evaluation != '' &&
          (form || {}).id_ref &&
          (form || {}).id_ref != 0 &&
          (form || {}).template &&
          (form || {}).template != {})
      );
    },
  },
};
</script>
